import React, { Children } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { TabPanelsProps } from '../types';
import { useTabContext } from '../TabContext';
import { renderTabPanelChild } from './helpers';

const TabPanels = ({ children, renderChildren = renderTabPanelChild, ...props }: TabPanelsProps) => {
  const context = useTabContext();

  return <Container {...props}>{Children.map(Children.toArray(children), renderChildren(context))}</Container>;
};

TabPanels.displayName = 'TabPanels';

export default TabPanels;
